import { pgEnum } from "drizzle-orm/pg-core";

export const articleStatusEnum = pgEnum("article_status", [
  "generating-idea", // The idea is currently being generated by the AI
  "scheduled-for-writing", // The idea is scheduled to be written
  "scheduled-for-publishing", // The idea is scheduled to be published
  "draft", // The article is in draft mode
  "writing", // The article is currently being generated
  "published", // The article is published
  "writing-failed", // failed to write the article
]);

export const usageMetricType = pgEnum("usage_metric_type", [
  "image-generation",
  "article-generation",
]);
